/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_SavingInputs */

const en_general_saving = /** @type {(inputs: General_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const de_general_saving = /** @type {(inputs: General_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {General_SavingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_saving = /** @type {((inputs?: General_SavingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_SavingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_saving(inputs)
	return de_general_saving(inputs)
});